import { CSSProperties, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Input, type InputProps } from '@ets/design-system';
import { ActionCreatorWithOptionalPayload } from '@reduxjs/toolkit';

import { useDebounce, useDispatch } from '_common/hooks';

type SearchProps = {
  search: ActionCreatorWithOptionalPayload<string | undefined>;
  margin: CSSProperties['margin'];
};

const Search = ({ search, margin }: SearchProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [value, setValue] = useState<string>();

  const debounceInputValue = useDebounce(value, 200);

  const handleSearchByChange: InputProps['onChange'] = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    dispatch(search(debounceInputValue));
  }, [debounceInputValue]);

  return (
    <Input
      size="m"
      placeholder={intl.formatMessage({ id: 'SEARCH_COMMENTS' })}
      value={value}
      prefix="search"
      onChange={handleSearchByChange}
      testId="sidebar-comments-search"
      margin={margin}
    />
  );
};

export default Search;
